import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Theme, { colors } from '../../themes';
import messages from '../messages';

const { newAdsTitle } = messages;

class NewAdsBanner extends React.PureComponent {
  render() {
    return (
      <div>
        <h5>
          <img src="/static/img/bell-title-icon.png" height="52" width="46" />
          <span>
            <FormattedMessage {...newAdsTitle} />:
          </span>
          <strong>{this.props.what}</strong>
        </h5>
        <style jsx>
          {`
            div {
              background: ${colors.grayExtraLight};
              padding: 12px 0px 17px 0px;
            }
            h5 {
              background: ${colors.blueExtraLight};
              border: 1px solid ${colors.blueLight};
              color: ${colors.grayDeep};
              border-radius: ${Theme.global.borderRadius};
              margin: 0px 10px 0px 31px;
              line-height: 1.5;
              padding: 7px 10px 8px 33px;
              position: relative;
              text-shadow: 0 1px 0 #fff;
            }
            h5 span {
              text-transform: uppercase;
              font-size: 0.75em; /* 12/16 */
            }
            h5 strong {
              text-transform: capitalize;
              margin: 0 5px;
            }
            h5 img {
              margin-right: 15px;
              position: absolute;
              left: -23px;
              top: -8px;
            }
            :global(.rtl) h5 {
              margin: 0px 31px 0px 10px;
              padding: 7px 33px 8px 10px;
            }
            :global(.rtl) h5 img {
              margin-right: 0;
              margin-left: 15px;
              left: auto;
              right: -23px;
            }
          `}
        </style>
      </div>
    );
  }
}

NewAdsBanner.defaultProps = {
  currentPage: 1,
};

NewAdsBanner.propTypes = {
  what: PropTypes.string.isRequired,
};

export default NewAdsBanner;



// WEBPACK FOOTER //
// ./app/Serp/components/NewAdsBanner.js